import store from '../store'

export function updateMessagePanelVisibility(docId,isVisible) {	
	store.dispatch({ type:'UPDATE_MESSAGE_PANEL_VISIBILITY',docId,isVisible})
}



